require('es6-shim');
require("@babel/polyfill");
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import './index.css';
// import App from './App';
import Routes from './containers/route';
import registerServiceWorker from './registerServiceWorker';

const store = configureStore();



const root = document.getElementById('root');

const lessStyleNode = document.createElement('link');
const lessConfigNode = document.createElement('script');
const lessScriptNode = document.createElement('script');
lessStyleNode.setAttribute('rel', 'stylesheet/less');
lessStyleNode.setAttribute('href', '/color.less');
lessConfigNode.innerHTML = `
  window.less = {
    async: true,
    env: 'production',
    javascriptEnabled: true
  };
`;
lessScriptNode.src = 'http://ybbh5.oss-cn-hangzhou.aliyuncs.com/js/less.min.js';
document.body.appendChild(lessStyleNode);
document.body.appendChild(lessConfigNode);
document.body.appendChild(lessScriptNode);

// 设置页面高度
let _Height = document.documentElement.clientHeight;
root.style.height = _Height + 'px';

const render = Component => {
    const renderMethod = module.hot ? ReactDOM.render : ReactDOM.hydrate;
    renderMethod(
        <Provider store={store}>
            <Component />

        </Provider>,
        root
    )
}

render(Routes)

if (module.hot) {
    module.hot.accept('./containers/route', () => { // 当我们热更新的代码出现的时候，把App重新加载
        const NextApp = require('./containers/route').default //因为在App里使用的是export default语法，这里使用的是require,默认不会加载default的，所以需要手动加上
        render(NextApp) // 重新渲染到 document 里面
    })
}

registerServiceWorker();

